import React from 'react';
import { injectIntl } from 'react-intl';
import { Row, Col, Button } from 'react-bootstrap';
import AnimateHeight from 'react-animate-height';

import { docTypeOptionFromEntity } from 'components/forms/autocomplete/DocType';

import EntityPropsUpdater from 'component/EntityPropsUpdater';

import FormLangInput from 'components/forms/FormLangInput';
import FormInput from 'components/forms/FormInput';
import FormSwitchery from 'components/forms/FormSwitchery';
import FormAutocomplete from 'components/forms/FormAutocomplete';

class PipelineStageData extends EntityPropsUpdater {
  constructor(props) {
    super(props);

    this.defaultFieldTree = ['stages', props.index];
  }

  addDocumentType = () => {
    const { data, entity, changeEntity } = this.props;

    let newValue = data.getRequireLeadDocuments().slice();
    const value = entity.createValue('requireLeadDocuments', ['stages', this.props.index]);
    newValue.push(value);

    let newEntity = { ...entity.updateValue('requireLeadDocuments', newValue, ['stages', this.props.index]) };

    changeEntity(newEntity);
  };

  removeDocumentType = index => {
    const { data, entity, changeEntity } = this.props;

    let newValue = data.getRequireLeadDocuments().slice();
    newValue.splice(index, 1);

    let newEntity = { ...entity.updateValue('requireLeadDocuments', newValue, ['stages', this.props.index]) };

    changeEntity(newEntity);
  };

  addClientDocumentType = () => {
    const { data, entity, changeEntity } = this.props;

    let newValue = data.getRequireClientDocuments().slice();
    const value = entity.createValue('requireClientDocuments', ['stages', this.props.index]);
    newValue.push(value);

    let newEntity = { ...entity.updateValue('requireClientDocuments', newValue, ['stages', this.props.index]) };

    changeEntity(newEntity);
  };

  removeClientDocumentType = index => {
    const { data, entity, changeEntity } = this.props;

    let newValue = data.getRequireClientDocuments().slice();
    newValue.splice(index, 1);

    let newEntity = { ...entity.updateValue('requireClientDocuments', newValue, ['stages', this.props.index]) };

    changeEntity(newEntity);
  };

  render() {
    const { data, intl, index, disabled } = this.props;
    const messages = intl.messages;

    return (
      <Row>
        <Col xs={12} md={6}>
          <div class="panel panel-transparent">
            <div class="panel-body">
              <p className="form-group-title">
                {messages.stage} {index + 1}
              </p>
              <div class="form-group-attached">
                <FormLangInput
                  label={messages.name}
                  name="name"
                  value={data.getName()}
                  meta={data.getNameMetaInformation()}
                  validation={data.getNameValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                />
                <FormInput
                  type="number"
                  label={messages.planned_duration_in_days}
                  name="deadlineDayCount"
                  value={data.getDeadlineDayCount() === null ? 2 : data.getDeadlineDayCount()}
                  meta={data.getDeadlineDayCountMetaInformation()}
                  validation={data.getDeadlineDayCountValidationResult()}
                  onChange={this.updateEntity}
                  disabled={disabled}
                />
              </div>
            </div>
          </div>
        </Col>
        <Col xs={12} md={6}>
          <div class="panel panel-transparent">
            <div class="panel-body">
              <p>{messages.settings}</p>
              <div class="">
                <div class="p-t-10">
                  <div class="p-b-5 form-group-title">{messages.lead_has_to_have_following_documents}</div>
                  <div class="form-group-attached">
                    {data.getRequireLeadDocuments().map((leadDocument, i) => {
                      return (
                        <div class="clearfix" key={i}>
                          <div class="pull-left text-center p-t-25" style={{ width: '50px' }}>
                            <a href="javascript:;" class="text-master" onClick={() => this.removeDocumentType(i)}>
                              <i class="fa fa-times" />
                            </a>
                          </div>
                          <div style={{ marginLeft: '50px' }}>
                            <FormAutocomplete
                              key={i}
                              label={messages.document + ' ' + (i + 1)}
                              name="docType"
                              autocompleteType="docType"
                              value={docTypeOptionFromEntity(leadDocument.getDocType())}
                              onChange={(name, value) => this.updateEntity(name, value, ['requireLeadDocuments', i])}
                              returnValueObject
                            />
                          </div>
                        </div>
                      );
                    })}
                  </div>
                  <div class="p-t-10">
                    <Button onClick={this.addDocumentType}>{messages.add_document_type}</Button>
                  </div>
                </div>
                <div class="p-t-30">
                  <FormSwitchery
                    label={messages.lead_budget_must_be_set}
                    name="isBudgetRequired"
                    checked={data.getIsBudgetRequired()}
                    value
                    onChange={this.updateEntity}
                  />
                </div>
                <div class="p-t-10">
                  <FormSwitchery
                    label={messages.client_must_be_assigned}
                    name="isClientRequired"
                    checked={data.getIsClientRequired()}
                    value
                    onChange={this.updateEntity}
                  />
                  <AnimateHeight duration={500} height={data.getIsClientRequired() ? 'auto' : 0}>
                    <div class="p-l-40 p-b-20 p-t-10">
                      <div class="form-group-title">{messages.client_has_to_have_following_documents}</div>
                      <div class="form-group-attached">
                        {data.getRequireClientDocuments().map((clientDocument, i) => {
                          return (
                            <div class="clearfix" key={i}>
                              <div class="pull-left text-center p-t-25" style={{ width: '50px' }}>
                                <a
                                  href="javascript:;"
                                  class="text-master"
                                  onClick={() => this.removeClientDocumentType(i)}
                                >
                                  <i class="fa fa-times" />
                                </a>
                              </div>
                              <div style={{ marginLeft: '50px' }}>
                                <FormAutocomplete
                                  key={i}
                                  label={messages.document + ' ' + (i + 1)}
                                  name="docType"
                                  autocompleteType="docType"
                                  value={docTypeOptionFromEntity(clientDocument.getDocType())}
                                  onChange={(name, value) =>
                                    this.updateEntity(name, value, ['requireClientDocuments', i])
                                  }
                                  returnValueObject
                                />
                              </div>
                            </div>
                          );
                        })}
                      </div>
                      <div class="p-t-10">
                        <Button onClick={this.addClientDocumentType}>{messages.add_document_type}</Button>
                      </div>
                    </div>
                  </AnimateHeight>
                </div>
                <div class="p-t-10">
                  <FormSwitchery
                    label={messages.order_must_be_assigned}
                    name="isOrderRequired"
                    checked={data.getIsOrderRequired()}
                    value
                    onChange={this.updateEntity}
                  />
                </div>
                <div class="p-t-10">
                  <FormSwitchery
                    label={messages.product_must_be_assigned}
                    name="isItemRequired"
                    checked={data.getIsItemRequired()}
                    value
                    onChange={this.updateEntity}
                  />
                </div>
                <div class="p-t-10">
                  <FormSwitchery
                    label={messages.handover_must_be_performed}
                    name="isHandoverRequired"
                    checked={data.getIsHandoverRequired()}
                    value
                    onChange={this.updateEntity}
                  />
                </div>
              </div>
            </div>
          </div>
        </Col>
      </Row>
    );
  }
}

export default injectIntl(PipelineStageData);
